import { ScrollUpButton } from "@fluidattacks/design";
import React, { useEffect, useState } from "react";

import { Chat } from "pages/dashboard/mcp-chat/chat";
import { useChatStore } from "pages/dashboard/mcp-chat/use-chat-store";

const ChatModal: React.FC = (): JSX.Element | undefined => {
  const [isExpanded, setIsExpanded] = useState<boolean>(false);
  const { isOpen } = useChatStore();

  useEffect((): void => {
    const zohoButton = document.querySelector('[data-id="zsalesiq"]');

    if (zohoButton === null) return;

    (zohoButton as HTMLElement).style.setProperty("position", "fixed");
    if (isExpanded || !isOpen) {
      (zohoButton as HTMLElement).style.setProperty("right", "20px");
    } else {
      (zohoButton as HTMLElement).style.setProperty("right", "420px");
    }
  }, [isExpanded, isOpen]);

  if (isOpen) {
    return (
      <React.Fragment>
        <Chat isExpanded={isExpanded} setIsExpanded={setIsExpanded} />
        <ScrollUpButton bottom={"10px"} right={isExpanded ? "60px" : "512px"} />
      </React.Fragment>
    );
  }

  return <ScrollUpButton bottom={"10px"} right={"72px"} />;
};

export { ChatModal };
